import React from "react";
import { NavLink } from "react-router-dom";
import { 
  LayoutDashboard, Users, CalendarDays, NotebookPen, Settings 
} from "lucide-react";

import { useAuth } from "@/contexts/AuthContext";

export default function BottomNav() {
  const { clinic } = useAuth();
  const myRole = clinic?.my_role || "professional";

  const allItems = [
    { to: "/app", icon: LayoutDashboard, label: "Início", end: true },
    { to: "/app/pacientes", icon: Users, label: "Pacientes" },
    { to: "/app/agenda", icon: CalendarDays, label: "Agenda" },
    { to: "/app/sessoes", icon: NotebookPen, label: "Sessões" },
    { to: "/app/configuracoes", icon: Settings, label: "Ajustes" },
  ];

  const filteredItems = allItems.filter(item => {
    if (myRole === 'admin') return true;
    if (myRole === 'receptionist') {
      return item.to !== '/app/sessoes';
    }
    return true;
  });

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg border-t border-[hsl(var(--border-divider))] px-2 pb-safe-area-inset-bottom">
      <div className="flex justify-around items-center h-16">
        {filteredItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 min-w-[64px] transition-colors ${
                isActive ? "text-[hsl(var(--brand))]" : "text-[hsl(var(--text-tertiary))]"
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
